import { useState } from 'react';
import { LinearProgress, Tabs } from '../../../tailwindcomponents';
import LoanedOutTools from './LoanedOutTools';
import ToolsOnStock from './ToolsOnStock';
import UserHistory from './UserHistory';
import ToolsLateReturns from './ToolsLateReturns';
import DefectiveReports from './DefectiveReports';
import UserCards from './UserCards';
import SyncMaintenerMxiTools from './SyncMaintenerMxiTools';
import { useQueryTab } from '../../../utils/usePersistedTab';

function ToolRegister() {
  const { tabValue, setTabValue } = useQueryTab("tab", 0);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <div className="w-full">
      {loading && <LinearProgress />}
      <Tabs
        tabNames={["Tools loaned out", "Search for tools on stock", "User History", "Denied", "Defective", "User Cards", "Update Tools"]}
        onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
        tabValue={tabValue}
      />
      {tabValue === 0 && <LoanedOutTools setLoading={setLoading} />}
      {tabValue === 1 && <ToolsOnStock setLoading={setLoading} />}
      {tabValue === 2 && <UserHistory setLoading={setLoading} />}
      {tabValue === 3 && <ToolsLateReturns setLoading={setLoading} />}
      {tabValue === 4 && <DefectiveReports setLoading={setLoading} />}
      {tabValue === 5 && <UserCards setLoading={setLoading} />}
      {tabValue === 6 && <SyncMaintenerMxiTools setLoading={setLoading} />}
    </div>
  );
}

export default ToolRegister;